export default function getQueryParamsFromMap(queryParams) {
  return Object.keys(queryParams || {})
    .reduce((previousValue, key) => {
      const value = (queryParams || {})[key];
      if (value != undefined && value != null) {
        previousValue.push(`${key}=${value}`);
      }
      return previousValue;
    }, [] as string[])
    .join("&");
}
